export const TabBarLoader = () => (
  <div className="mb-6 flex items-center space-x-2">
    <div className="bg-tertiary w-18 h-[38px] animate-pulse rounded-full duration-300" />
    <div className="bg-tertiary w-18 h-[38px] animate-pulse rounded-full duration-300" />
    <div className="bg-tertiary h-[38px] w-[106px] animate-pulse rounded-full duration-300" />
    <div className="bg-tertiary h-[38px] w-[84px] animate-pulse rounded-full duration-300" />
    <div className="bg-tertiary h-[38px] w-[90px] animate-pulse rounded-full duration-300" />
  </div>
);
